export const trakrefBlue = "#008299";

export const trakrefYellow = "#FFBB00";

export const Grey1 = "#1A173B";

export const Grey2 = "#44474A";

export const Grey3 = "#6D7588";

export const Grey4 = "#F5F5F5";

export const Grey5 = '#656565';

export const Grey6 = '#EAEAEA';

export const Grey7 = '#F2F2F3';

export const Grey8 = '#757575';

export const DividerColor = '#DCDCDC';

export const HoverColor = '#ECF2F3';

export const darkGray = '#1A2027';

export const White = "#FFFFFF";

export const lightBlue = "#00798F";

export const Black = "#1B2125";

export const trakrefDisabledBlue = "#7FC0CC";

export const lightGrayColor = "rgba(216,216,216,0.15)";

export const white = "#FFFFF";

export const toolTipBlue = "#00B0B9";

export const orange = "#FFBB00";

export const pillOrange = "#FFE6C0";

export const green = "#8BDC54";

export const teal = "#009688";

export const purple = "#673ab7";

export const darkTeal = "#037285";

export const inputGrey = "#F1F3F4";

export const red = "#D51A1A";

export const lightRed = "#fbeded";

export const inactiveStatusColor = "#D1D9DE";

export const focusColor = "#D8E0F3";

export const mediumGray = "#4B5563";

export const darkestGray = "#111827";

export const selectedButton = "#ecf8fb";

export const chromeDividerColor = "#D9DCE3";

export const chromeMutedTextColor = "#AEB7C4";

export const chromeMutedLabelColor = "#B8BEC9";

export const chromeInfoBackground = "#E5F6FA";

export const chromeActiveHoverColor = "#2696A8";

export const selectedButtonWhite = "#ecf8fb";

export const determineColorStatus = (status) => {
    let color = null
    const statusToLowerCase = status?.toLowerCase() || ''; // Prevent null from default case when status is undefined
    switch (statusToLowerCase) {
        case 'work completed':
        case 'operational':
            color = green
            break;
        case 'cancelled':
        case 'deactivated':
            color = inactiveStatusColor
            break;
        case 'open':
            color = orange
            break;
        case 'closed':
            color = trakrefBlue;
            break;
        case 'deleted':
            color = red;
            break;
        default:
            color = green
            break;
    }
    return color;
};

// Consumed by develop's Analytics/LeakRateCompliance page. Ids are environment-coupled;
// prefer getChartColor(name) from Utils/charts_utils for new code. Id 12 is the
// EPA 608_S157 row, displayed as "EPA 608" since AB#15271.
export const regulatedAssetTagColors = {
    1: "#009688",
    2: "#ffc107",
    3: "#2196f3",
    4: "#C2185B",
    6: "#9C27B0",
    8: "#ec407a",
    12: "#009688",
    31: "#AB4E01",
};